export default {
    "已有账号？": "已有账号？",
    "去登录": "去登录",
    "首次登录，请选择语言": "首次登录，请选择语言",
    "立即切换": "立即切换",
    "投注": "投注",
    "请先绑定银行卡": "请先绑定银行卡",
    "历史": "历史",
    "绑定上限，请联系客服!": "绑定上限，请联系客服!",
    "已达绑定上限": "已达绑定上限",
    "任务详情": "任务详情",
    "投票详情": "投票详情",
    "获得金额": "获得金额",
    "待结算": "待结算",
    "再来一次": "再来一次",
    "时间": "时间",
    "备注": "备注",
    "服务评分": "服务评分",

    accountDetailTab: {
      "充值": '充值',
      "提现": '提现',
      "投票": '投票详情',
    },
    "选择{name}": "选择{name}",
    "个人简介": "个人简介",
    "投票金额": "投票金额",
    "投票记录": "投票记录",
    "投票方向": "投票方向",
    "下注金额": "下注金额",
    "我已经知晓并同意'开户协议'各项条约": "我已经知晓并同意'开户协议'各项条约",
    "投票": "投票",
    "确认投票": "确认投票",
    "银行账户号码": "银行账户号码",
    "提现到": "提现到",
    "去绑定": "去绑定",
    "信誉分": "信誉分",
    "取款方式": "取款方式",
    "立即预约": "立即预约",
    "住所": "住所",
    "照片": "照片",
    "胸围": "胸围",
    "约炮推荐": "约炮推荐",
    "高端专区": "高端专区",
    "暂无信息": "暂无信息",
    "观影券": "观影券",
    "观影券不足": "观影券不足",
    "详情信息": "详情信息",
    "银行卡": "银行卡",
    "x次认证": "{num}次认证",
    "请输入您的收款卡信": "请输入您的收款卡信",
    "绑定银行卡": "绑定银行卡",
    "绑定USDT地址": "绑定USDT地址",
    "请选择{name}": "请选择{name}",
    "请输入{name}": "请输入{name}",
    "银行地址": "银行地址",
    "银行账户": "银行账户",
    "ABA/路由代码": "ABA/路由代码",
    "SWIFT代码": "SWIFT代码",
    "姓名": "姓名",
    "虚拟币": "虚拟币",
    "币种": "币种",
    "地址": "地址",
    "确认绑定": "确认绑定",
    "银行列表": "银行列表",
    "暂无数据": "暂无数据",
    '充值': '充值',
    '旧密码': '旧密码',
    '新密码': '新密码',
    '请输入您的旧密码': '请输入您的旧密码',
    '请输入您的新密码': '请输入您的新密码',
    '请再次输入您的新密码': '请再次输入您的新密码',
    '修改登录密码': '修改登录密码',
    '收款卡信息': '收款卡信息',
    '投票结果': '投票结果',
    tabbar: {
        '首页': '首页',
        '预约': '预约',
        '地区选择': '地区选择',
        '视频': '视频',
        '我的': '我的'
    },
    "高端": "高端",
    '认证': '认证',
    '视频认证': '视频认证',
    '收费区间': '收费区间',
    '身高': '身高',
    '胸圍': '胸圍',
    '服務城市': '服務城市',
    '全國空降': '全國空降',
    '是': '是',
    '否': '否',
    '我要约她': '我要约她',
    '城市大全': '城市大全',
    '流程价格': '流程价格',
    '刷新成功': '刷新成功',
    '预约大厅': '预约大厅',
    '全部': '全部',
    '查看更多': '查看更多',
    '推荐任务': '推荐任务',
    '人气排行': '人气排行',
    '热门推荐': '热门推荐',
    '获取中': '获取中',
    '语言': '语言',
    '登录': '登录',
    '忘记密码': '忘记密码',
    '没有账户？马上注册': '没有账户？马上注册',
    '请输入用户名': '请输入用户名',
    '请输入密码': '请输入密码',
    '注册': '注册',
    '我已经知晓并同意"开户协议"各项条约': '我已经知晓并同意"开户协议"各项条约',
    '请输入邀请码': '请输入邀请码',
    '请输入用户名({min}-{max}个英文字母或数字)': '请输入用户名({min}-{max}个英文字母或数字)',
    '请输入登录密码({min}-{max}个英文字母或数字)': '请输入登录密码({min}-{max}个英文字母或数字)',
    '请勾选下方开户协议': '请勾选下方开户协议',
    '可用余额': '可用余额',
    '元': '元',
    '提交': '提交',
    '当前选号': '当前选号',
    '每注金额': '每注金额',
    '请输入金额': '请输入金额',
    '总共': '总共',
    '注': '注',
    '合计': '合计',
    '任务单': '任务单',
    '1注X{money}元={money}元': '1注X{money}={money}',
    '清空订单': '清空订单',
    '确认提交': '确认提交',
    '期号': '期号',
    '第{x}期': '第{x}期',
    '数据': '数据',
    '双': '双',
    '单': '单',
    '未选择': '未选择',
    '金额错误': '金额错误',
    '请选号': '请选号',
    '请填写金额': '请填写金额',
    '余额不足，请联系客服充值！': '余额不足，请联系客服充值！',
    '未选中': '未选中',
    '请联系管理员领取该任务': '请联系管理员领取该任务',
    '开奖成功，期号：': '开奖成功，期号：',
    '大': '大',
    '小': '小',
    '填写收款卡': '填写收款卡',
    '请输入您的收款卡信息': '请输入您的收款卡信息',
    '银行卡号': '银行卡号',
    '请输入真实银行卡号': '请输入真实银行卡号',
    '银行名称': '银行名称',
    '请选择银行': '请选择银行',
    '尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款': '尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款',
    '确认绑卡': '确认绑卡',
    '请输入银行卡号': '请输入银行卡号',
    '任务记录': '任务记录',
    '任务记录Title': '任务记录',
    '数据为空': '数据为空',
    '下单时间': '下单时间',
    '结算时间': '结算时间',
    '提现': '提现',
    '我的钱包': '我的钱包',
    '详情': '详情',
    '余额': '余额',
    '个人报表': '个人报表',
    '账户明细': '账户明细',
    '个人中心': '个人中心',
    '信息公告': '信息公告',
    '在线客服': '在线客服',
    '请完成任务单后进入': '请完成任务单后进入',
    '请联系客服充值': '请联系客服充值',
    '请设置收款卡': '请设置收款卡',
    '功能已禁用': '功能已禁用',
    '账号下线': '账号下线',
    '登录/注册': '登录/注册',
    '登录可享受更多服务': '登录可享受更多服务',
    '基本信息': '基本信息',
    '头像': '头像',
    '选择头像': '选择头像',
    '确定': '确定',
    '取消': '取消',
    '真实姓名': '真实姓名',
    '未设置': '未设置',
    '性别': '性别',
    '绑定信息': '绑定信息',
    '已绑定': '已绑定',
    '无': '无',
    '男': '男',
    '女': '女',
    '未知': '未知',
    '系统公告': '系统公告',
    '盈利金额': '盈利金额',
    '盈利计算公式 : 中奖金额 - 任务金额': '盈利计算公式 : 中奖金额 - 任务金额',
    '任务金额': '任务金额',
    '充值金额': '充值金额',
    '提现金额': '提现金额',
    '中奖金额': '中奖金额',
    '客服': '客服',
    '蜜獾娱乐': '蜜獾娱乐',
    '联系': '联系',
    '全天7 * 24小时竭诚为您服务': '全天7 * 24小时竭诚为您服务',
    '添加收款卡': '添加收款卡',
    '提示:请绑定大型商业银行,如需修改,请您联系在线客服': '提示:请绑定大型商业银行,如需修改,请您联系在线客服',
    '修改真实姓名': '修改真实姓名',
    '保存': '保存',
    '请输入真实姓名': '请输入真实姓名',
    '为了您账户安全,真实姓名需要与绑定银行卡姓名一致': '为了您账户安全,真实姓名需要与绑定银行卡姓名一致',
    '请勿重复设置': '请勿重复设置',
    '请输入姓名': '请输入姓名',
    '请输入资金密码': '请输入资金密码',
    '设置资金密码': '设置资金密码',
    '请再次输入资金密码': '请再次输入资金密码',
    '请填写完整': '请填写完整',
    '两次密码不一致': '两次密码不一致',
    '性别修改': '性别修改',
    '设置': '设置',
    '基本信息设置': '基本信息设置',
    '登录密码': '登录密码',
    '资金密码': '资金密码',
    '退出登录': '退出登录',
    '已设置': '已设置',
    '提现密码已设置，需要修改请联系客服': '提现密码已设置，需要修改请联系客服',
    '提现中心': '提现中心',
    '提现记录': '提现记录',
    '1.单笔限额：最低{min}元，最高{max}元': '1.单笔限额：最低{min}，最高{max}',
    '2.提现次数：一天最高提现{num}次': '2.提现次数：一天最高提现{num}次',
    '3.到账时间': '3.到账时间：约15分钟，最迟2小时内到账',
    '限额说明': '限额说明',
    '马上提现': '马上提现',
    '请填写正确的金额': '请填写正确的金额',
    '金额': '金额',
    '说明': '说明',
    '提交时间': '提交时间',
    '审核时间': '审核时间',
    '视频影院': '视频影院',
    '没有更多了': '没有更多了',
    '播放': '播放',
    'x播放': '{count}播放',
    '首页': '首页',
    '选妃': '选妃',
    '选妃列表': '选妃列表',
    '选妃详情': '选妃详情',
    '语言选择': '语言选择',
    '我的': '我的',
    '视频': '视频',
    '游戏': '游戏',
    '修改性别': '修改性别',
    '支付密码管理': '支付密码管理',
    '登录密码管理': '登录密码管理',
    '详情页面': '详情页面',
    '视频播放': '视频播放',
}
